import store from '../store/store';
import config from '../config'
import signals from '../store/signals'

function Resize (){
  let resizeId

  function init () {
    resize();
    window.addEventListener('resize', resize);

    setTimeout(resize, 100)
    const inter = setInterval(resize, 500)
    setTimeout(() => clearInterval(inter), 5000)
  }

  function remove () {
    window.removeEventListener('resize', resize);
  }

  function resize (e) {
    store.resize.set({ width: window.innerWidth, height: window.innerHeight });

    // site-max-width: no max width
    // site-padding: 0
    // site-padding-mobile: 20

    if (window.innerWidth <= 900) {
      document.documentElement.style.setProperty('--vw', Math.min(window.innerWidth - (20 * 2), 900) + 'px')
    } else {
      document.documentElement.style.setProperty('--vw', window.innerWidth - (0 * 2) + 'px')
    }

    config.wide = window.innerWidth <= 1200;
    config.small = window.innerWidth <= 900;
    config.smaller = window.innerWidth <= 480;

    clearTimeout(resizeId)
    resizeId = setTimeout(doneResize, 300)
  }

  function doneResize () {
    signals.resizeEnd.dispatch()
  }

  return {
    init,
    remove,
  };
}
export default Resize();
